<template>
    <div
        class="o-mobile-search-header mobile-search-header"
    >
        <AMBackButton
            theme="back"
            text=""
            @onClick="handleBackClick"
        />
        <div class="o-mobile-search-header__info">
            <span class="o-mobile-search-header__info__title">{{title}}</span><br>
            <span class="o-mobile-search-header__info__subtitle">{{subtitle}}</span>
        </div>
        <slot name="rightIcon">
            <div class="o-mobile-search-header__icon">
                <svg-icon
                    original
                    name="icons/search_mobile"
                />
            </div>
        </slot>
    </div>
</template>

<script>

import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import {MOBILE_SEARCH} from "@/utils/constants/pages";

export default {
    name: "OMobileSearchHeader",
    props: {
        title:{
            type: String,
            default: function() {
                return this.$t('ui.mobile-search-title')
            } 
        },
        subtitle:{
            type: String,
            default: function() {
                return this.$t('ui.mobile-search-subtitle')
            } 
        }
    },
    components: {
        AMBackButton
    },
    methods: {
        handleBackClick() {
            this.hasHistory() 
                ? this.$router.back() 
                : $router.push({
                    name: MOBILE_SEARCH,
                })
        },
        hasHistory () { 
            return window.history.length >= 2
        }
    }

}
</script>

<style lang="scss">
@import "o-mobile-search-header";
</style>
